import { $host, handleError, handleResponse } from "./index";

export const getCart = async () => {
    try {
        const res = await $host.get(`/api/payments/cart`, { withCredentials: true });
        return handleResponse(res);
    } catch (error) {
        handleError(error);
    }
};

export const addToCart = async (payload) => {
    try {
        const res = await $host.post(`/api/payments/cart/add`, payload, { withCredentials: true });
        return handleResponse(res);
    } catch (error) {
        handleError(error);
    }
};

export const checkoutCart = async (body) => {
    try {
        const res = await $host.post(`/api/payments/initiate`, body, { withCredentials: true });

        return handleResponse(res);
    } catch (error) {
        handleError(error);
    }
};

export const removeFromCart = async (payload) => {
    try {
        const res = await $host.delete(`/api/payments/cart/remove`, { data: payload }, { withCredentials: true });
        return handleResponse(res);
    } catch (error) {
        handleError(error);
    }
};